const PageNotFound = () => import('./views')

const routes = [{ path: '*', component: PageNotFound, name: 'pageNotFound' }]

export default routes
